/* Veil — hide the floating navbar on scroll-down, reveal on scroll-up,
   so it never collides with content while reading. */
(() => {
  const nav = document.querySelector('.nav');
  if (!nav) return;

  let last = window.scrollY;
  let ticking = false;
  const SHOW_ABOVE = 120;   // always visible near the top
  const DELTA = 6;          // ignore tiny jitters

  function update() {
    const y = window.scrollY;
    if (nav.classList.contains('nav--open')) { last = y; ticking = false; return; } // don't hide while menu open
    if (y > SHOW_ABOVE && y > last + DELTA) {
      nav.classList.add('nav--hidden');      // scrolling down
    } else if (y < last - DELTA || y <= SHOW_ABOVE) {
      nav.classList.remove('nav--hidden');   // scrolling up / near top
    }
    last = y;
    ticking = false;
  }

  addEventListener('scroll', () => {
    if (!ticking) { requestAnimationFrame(update); ticking = true; }
  }, { passive: true });

  // mobile menu toggle
  const toggle = nav.querySelector('.nav__toggle');
  if (toggle) {
    const setOpen = (open) => {
      nav.classList.toggle('nav--open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      document.body.style.overflow = open ? 'hidden' : '';
    };
    toggle.addEventListener('click', () => setOpen(!nav.classList.contains('nav--open')));
    nav.querySelectorAll('.nav__links a').forEach(a =>
      a.addEventListener('click', () => setOpen(false)));
    addEventListener('keydown', (e) => { if (e.key === 'Escape') setOpen(false); });
  }
})();

/* NOTE (Shopify theme): the prototype's graceful-form-feedback block was removed
   here — the newsletter and commission enquiry are now real Shopify forms
   ({% form 'customer' %} / contact form) that must submit natively. Success
   messaging is rendered server-side via form.posted_successfully?. */
